import { STORES_AND_ADDRESSES_PAGE_CONSOLIDATION_240703 } from "@faire/web-api/indigofair/settings/STORES_AND_ADDRESSES_PAGE_CONSOLIDATION_240703";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingEnableStoresAndAddressConsolidation = (): boolean => {
  return useSetting(STORES_AND_ADDRESSES_PAGE_CONSOLIDATION_240703, false);
};
